<app-progress-spinner *ngIf="!showform || submitted"></app-progress-spinner>
<div>
    <main>
        <div *ngIf="showform" class="projectStyle container">
            <form (keydown.enter)="$event.preventDefault()" [formGroup]="projectForm" (ngSubmit)="submit($event)">
                <div class="col-md-12 col-lg-12 label-header">
                    <label class="label-headercolor label-text">Organization </label>
                </div>
                <div class="row" style="margin-bottom: 10px;">
                    <div class="col-md-3 col-lg-3">
                        <label for="businessArea" class="label">Business Area <span class="asterisk_input">*</span>
                        </label>
                    </div>
                    <div class="col-md-3 col-lg-3">
                        <select id="businessArea" class="form-control invalid" aria-label="businessArea"
                            formControlName="businessAreaName"
                            style="margin-top: 4px; height: 30px !important; font-size: 0.7rem !important; padding: 1px;"
                            (change)="updateBusinessArea()">
                            <option value="">Please select</option>
                            <option *ngFor="let ba of roleBusinessArea" [value]="ba.BusinessAreaId">
                                {{ba.BusinessAreaName}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-3 col-lg-3">
                        <label for="businessLine" class="label">Business Line <span class="asterisk_input">*</span>
                        </label>
                    </div>
                    <div class="col-md-3 col-lg-3">
                        <select id="businessLine" class="form-control invalid" aria-label="businessLine"
                            formControlName="businessLineName"
                            style="margin-top: 4px; height: 30px !important; font-size: 0.7rem !important; padding: 1px;"
                            (change)="updateBusinessLine()">
                            <option value="">Please select</option>
                            <option *ngFor="let bl of roleBusinessLine" [value]="bl.BusinessLineId">
                                {{bl.BusinessLineName}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-md-12 col-lg-12 label-header">
                    <label class="label-headercolor label-text">Team </label>
                </div>

                <div class="row row-height row row-height-height row-style" style="margin-bottom: 10px;">
                    <div class="col-md-6 col-lg-6" style="border-right: 1px solid;">
                        <div class="row">
                            <div class="teamLabel">
                                <label>Product Manager <span class="asterisk_input">*</span> </label>
                            </div>
                            <div class="peoplepickerStyle">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <form [formGroup]="productManagerPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('productM')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['ProductManager'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="productManagerPeoplePickr"
                                                (closed)="clearSearch('ProductManager')"
                                                (click)="autofocus('productM')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputProductM type="text"
                                                        [formControl]="searchInputProductManager"
                                                        (input)="fetchUserData($event, false, 'ProductManager')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['ProductManager'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['ProductManager'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['ProductManager'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['ProductManager'].searchData; let i = index"
                                                    [value]="user" (click)="getDetails(user, 'ProductManager')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> (
                                        {{dynamicFieldsData['ProductManager'].oldData.length}} )</span>
                                </div>
                            </div>
                            <div class="activeToggle">
                                <mat-slide-toggle class="approval-toggle" formControlName="approvalProductManager">
                                    <label>Accept</label>
                                </mat-slide-toggle>
                            </div>
                            <div class="proxyStyle">
                                <label>Proxy</label>
                            </div>
                            <div class="peoplepickerStyle">
                                <div class="textfield js-textfield textfield-with-prefix">

                                    <form [formGroup]="proxyProductManagerPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('pproductM')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['ProductManagerProxy'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="proxyProductManagerPeoplePickr"
                                                (closed)="clearSearch('ProductManagerProxy')"
                                                (click)="autofocus('pproductM')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputproxyProductM type="text"
                                                        [formControl]="searchInputProxyProductManager"
                                                        (input)="fetchUserData($event, false, 'ProductManagerProxy')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['ProductManagerProxy'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['ProductManagerProxy'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['ProductManagerProxy'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['ProductManagerProxy'].searchData; let i = index"
                                                    [value]="user" (click)="getDetails(user, 'ProductManagerProxy')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> ( {{dynamicFieldsData['ProductManagerProxy'].oldData.length}}
                                        )</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="row">
                            <div class="teamLabel">
                                <label>Service Manager</label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <form [formGroup]="serviceManagerPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('serviceM')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['servicemanager'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="serviceManagerPeoplePickr"
                                                (closed)="clearSearch('servicemanager')"
                                                (click)="autofocus('serviceM')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputServiceM type="text"
                                                        [formControl]="searchInputServiceManager"
                                                        (input)="fetchUserData($event, false, 'servicemanager')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['servicemanager'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['servicemanager'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['servicemanager'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['servicemanager'].searchData; let i = index"
                                                    [value]="user" (click)="getDetails(user, 'servicemanager')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}

                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> ( {{dynamicFieldsData['servicemanager'].oldData.length}}
                                        )</span>
                                </div>
                            </div>
                            <div class="activeToggle">
                                <mat-slide-toggle class="approval-toggle" formControlName="approvalServiceManager">
                                    <label>Accept</label>
                                </mat-slide-toggle>
                            </div>
                            <div class="proxyStyle">
                                <label>Proxy </label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <form [formGroup]="proxyServiceManagerPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('pserviceM')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select panelClass="proxy-right" style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['servicemanagerProxy'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="proxyServiceManagerPeoplePickr"
                                                (closed)="clearSearch('servicemanagerProxy')"
                                                (click)="autofocus('pserviceM')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputproxyServiceM type="text"
                                                        [formControl]="searchInputProxyServiceManager"
                                                        (input)="fetchUserData($event, false, 'servicemanagerProxy')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['servicemanagerProxy'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['servicemanagerProxy'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['servicemanagerProxy'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['servicemanagerProxy'].searchData; let i = index"
                                                    [value]="user" (click)="getDetails(user, 'servicemanagerProxy')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}

                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> ( {{dynamicFieldsData['servicemanagerProxy'].oldData.length}}
                                        )</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row row-height row row-height-height row-style" style="margin-bottom: 10px;">
                    <div class="col-md-6 col-lg-6" style="border-right: 1px solid;">
                        <div class="row">
                            <div class="teamLabel">
                                <label>Financial Controller <span class="asterisk_input">*</span></label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <form [formGroup]="financialControllerPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('fc')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['Financialcontroller'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="financialControllerPeoplePickr"
                                                (closed)="clearSearch('Financialcontroller')" (click)="autofocus('fc')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputFC type="text"
                                                        [formControl]="searchInputFinancialController"
                                                        (input)="fetchUserData($event, false, 'Financialcontroller')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['Financialcontroller'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['Financialcontroller'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['Financialcontroller'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['Financialcontroller'].searchData; let i = index"
                                                    [value]="user" (click)="getDetails(user, 'Financialcontroller')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> (
                                        {{dynamicFieldsData['Financialcontroller'].oldData.length}} )</span>
                                </div>
                            </div>
                            <div class="activeToggle">
                                <mat-slide-toggle class="approval-toggle" formControlName="approvalFinancialController">
                                    <label>Accept</label>
                                </mat-slide-toggle>
                            </div>
                            <div class="proxyStyle">
                                <label>Proxy </label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <form [formGroup]="proxyFinancialControllerPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('pfc')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['FinancialcontrollerProxy'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="proxyFinancialControllerPeoplePickr"
                                                (closed)="clearSearch('FinancialcontrollerProxy')"
                                                (click)="autofocus('pfc')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputproxyFC type="text"
                                                        [formControl]="searchInputProxyFinancialController"
                                                        (input)="fetchUserData($event, false, 'FinancialcontrollerProxy')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['FinancialcontrollerProxy'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['FinancialcontrollerProxy'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['FinancialcontrollerProxy'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['FinancialcontrollerProxy'].searchData; let i = index"
                                                    [value]="user"
                                                    (click)="getDetails(user, 'FinancialcontrollerProxy')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> ( {{dynamicFieldsData['FinancialcontrollerProxy'].oldData.length}}
                                        )</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="row">
                            <div class="teamLabel">
                                <label>Procurement Engineer </label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <form [formGroup]="procurementEngineerPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('pe')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['ProcurementEngineer'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="procurementEngineerPeoplePickr"
                                                (closed)="clearSearch('ProcurementEngineer')" (click)="autofocus('pe')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputPE type="text"
                                                        [formControl]="searchInputProcurementEngineer"
                                                        (input)="fetchUserData($event, false, 'ProcurementEngineer')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['ProcurementEngineer'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['ProcurementEngineer'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['ProcurementEngineer'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['ProcurementEngineer'].searchData; let i = index"
                                                    [value]="user" (click)="getDetails(user, 'ProcurementEngineer')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> (
                                        {{dynamicFieldsData['ProcurementEngineer'].oldData.length}} )</span>
                                </div>
                            </div>
                            <div class="activeToggle">
                                <mat-slide-toggle class="approval-toggle" formControlName="approvalProcurementEngineer">
                                    <label>Accept</label>
                                </mat-slide-toggle>
                            </div>
                            <div class="proxyStyle">
                                <label>Proxy </label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <form [formGroup]="proxyProcurementEngineerPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('ppe')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select panelClass="proxy-right" style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['ProcurementEngineerProxy'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="proxyProcurementEngineerPeoplePickr"
                                                (closed)="clearSearch('ProcurementEngineerProxy')"
                                                (click)="autofocus('ppe')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputproxyPE type="text"
                                                        [formControl]="searchInputProxyProcurementEngineer"
                                                        (input)="fetchUserData($event, false, 'ProcurementEngineerProxy')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['ProcurementEngineerProxy'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['ProcurementEngineerProxy'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['ProcurementEngineerProxy'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['ProcurementEngineerProxy'].searchData; let i = index"
                                                    [value]="user"
                                                    (click)="getDetails(user, 'ProcurementEngineerProxy')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> ( {{dynamicFieldsData['ProcurementEngineerProxy'].oldData.length}}
                                        )</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row row-height row row-height-height row-style" style="margin-bottom: 10px;">
                    <div class="col-md-6 col-lg-6" style="border-right: 1px solid;">
                        <div class="row">
                            <div class="teamLabel">
                                <label>Project Manager </label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class="textfield js-textfield textfield-with-prefix">

                                    <form [formGroup]="projectManagerPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('projectM')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['projectmanager'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="projectManagerPeoplePickr"
                                                (closed)="clearSearch('projectmanager')"
                                                (click)="autofocus('projectM')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputProjectM type="text"
                                                        [formControl]="searchInputProjectManager"
                                                        (input)="fetchUserData($event, false, 'projectmanager')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['projectmanager'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['projectmanager'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['projectmanager'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['projectmanager'].searchData; let i = index"
                                                    [value]="user" (click)="getDetails(user, 'projectmanager')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> ( {{dynamicFieldsData['projectmanager'].oldData.length}}
                                        )</span>
                                </div>
                            </div>
                            <div class="activeToggle">
                                <mat-slide-toggle class="approval-toggle" formControlName="approvalProjectManager">
                                    <label>Accept</label>
                                </mat-slide-toggle>
                            </div>
                            <div class="proxyStyle">
                                <label>Proxy </label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class="textfield js-textfield textfield-with-prefix">

                                    <form [formGroup]="proxyProjectManagerPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('pprojectM')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['projectmanagerProxy'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="proxyProjectManagerPeoplePickr"
                                                (closed)="clearSearch('projectmanagerProxy')"
                                                (click)="autofocus('pprojectM')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputproxyProjectM type="text"
                                                        [formControl]="searchInputProxyProjectManager"
                                                        (input)="fetchUserData($event, false, 'projectmanagerProxy')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['projectmanagerProxy'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['projectmanagerProxy'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['projectmanagerProxy'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['projectmanagerProxy'].searchData; let i = index"
                                                    [value]="user" (click)="getDetails(user, 'projectmanagerProxy')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> ( {{dynamicFieldsData['projectmanagerProxy'].oldData.length}}
                                        )</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="row">
                            <div class="teamLabel">
                                <label>Project Team </label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class=" js-textfield textfield-with-prefix">

                                    <!-- <div class="center-cell-content"> -->
                                        <button type="button" class="edit-btn" [disabled]="isDisabled"  (click)="editData(params)" title="Edit" >
                                          <img src="/assets/edit.svg" height="25" width="20" alt="Edit Icon"/> <label>Configure access rights </label>
                                        </button>
                                      </div> 
                           
                                <!-- <div class="peopleCount">
                                    <span> ( {{dynamicFieldsData['Watchlist'].oldData.length}}
                                        )</span>
                                </div> -->
                            </div>

                           
                        </div>
                    </div>
                </div>

                <div class="row row-height row row-height-height row-style" style="margin-bottom: 10px;">
                    <div class="col-md-6 col-lg-6" style="border-right: 1px solid; height: 35px;">
                        <div class="row">
                            <div class="teamLabel">
                                <label> Lead System Engineer </label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class="textfield js-textfield textfield-with-prefix">

                                    <form [formGroup]="systemArchitectPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('sa')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['SystemArchitect'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="systemArchitectPeoplePickr"
                                                (closed)="clearSearch('SystemArchitect')" (click)="autofocus('sa')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputSA type="text" [formControl]="searchInputSystemArchitect"
                                                        (input)="fetchUserData($event, false, 'SystemArchitect')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['SystemArchitect'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['SystemArchitect'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['SystemArchitect'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['SystemArchitect'].searchData; let i = index"
                                                    [value]="user" (click)="getDetails(user, 'SystemArchitect')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> ( {{dynamicFieldsData['SystemArchitect'].oldData.length}}
                                        )</span>
                                </div>
                            </div>
                            <div class="activeToggle">
                                <mat-slide-toggle class="approval-toggle" formControlName="approvalSystemArchitect">
                                    <label>Accept</label>
                                </mat-slide-toggle>
                            </div>
                            <div class="proxyStyle">
                                <label>Proxy </label>
                            </div>
                            <div class="peoplepickerStyle" style="display: flex;">
                                <div class="textfield js-textfield textfield-with-prefix">

                                    <form [formGroup]="proxySystemArchitectPeoplePickr"
                                        style="width: 100%; position: absolute" (click)="autofocus('psa')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                      font-size: 0.7rem;
                                      position: relative;
                                    " [ngStyle]="{'top': dynamicFieldsData['SystemArchitectProxy'].oldData.length > 1 ? '-28px' : '-17px'}"
                                                multiple formControlName="proxySystemArchitectPeoplePickr"
                                                (closed)="clearSearch('SystemArchitectProxy')"
                                                (click)="autofocus('psa')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputproxySA type="text"
                                                        [formControl]="searchInputProxySystemArchitect"
                                                        (input)="fetchUserData($event, false, 'SystemArchitectProxy')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger style="white-space: normal; font-size: 0.7rem;">

                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        *ngIf="dynamicFieldsData['SystemArchitectProxy'].oldData.length !== 0"
                                                        [ngStyle]="{'height': dynamicFieldsData['SystemArchitectProxy'].oldData.length > 1 ? '30px' : '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 20px !important;">
                                                            <li *ngFor="let i of dynamicFieldsData['SystemArchitectProxy'].userData"
                                                                class="dropdown-style">
                                                                {{ i }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of dynamicFieldsData['SystemArchitectProxy'].searchData; let i = index"
                                                    [value]="user" (click)="getDetails(user, 'SystemArchitectProxy')"
                                                    id="user{{i}}">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <div class="peopleCount">
                                    <span> ( {{dynamicFieldsData['SystemArchitectProxy'].oldData.length}}
                                        )</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="row">
                            <div class="teamLabel">
                                <label>Submitter <span class="asterisk_input">*</span> </label>
                            </div>
                            <div class="peoplepickerStyle">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <form [formGroup]="submitterPeoplePickr" style="width: 100%; position: absolute"
                                        (click)="autofocus('sub')">
                                        <mat-form-field appearance="legacy" class="myPanel no-underline">
                                            <mat-select style="
                                                font-size: 0.7rem;
                                                padding-left: 10px;
                                                position: relative;
                                                top: -17px;
                                                " formControlName="submitterPeoplePickr"
                                                (closed)="clearSearch('submitter')" (click)="autofocus('sub')">
                                                <mat-form-field [floatLabel]="'never'"
                                                    class="no-underline no-wrapper sticky-search">
                                                    <mat-label class="search-label">Search Email...</mat-label>
                                                    <input role="textbox" style="
                                          padding-left: 10px;
                                          position: relative;
                                          top: -2px;
                                          border: 1px solid blue;
                                          box-shadow: 0px 0px 6px;
                                          border-radius: 2px;
                                          width: 100%;
                                          height: 20px;
                                          bottom: 4px;
                                          align-items: center;
                                        " matInput #myInputSub type="text" [formControl]="searchInputSubmitter"
                                                        (input)="fetchUserData($event, false, 'submitter')"
                                                        autocomplete="off" />
                                                </mat-form-field>
                                                <mat-option class="mat-option-hide" disabled></mat-option>
                                                <mat-select-trigger role="textbox" aria-label="peoplePicker">
                                                    <div style="height: 15px; width: 100%; overflow-y: hidden;"
                                                        [ngStyle]="{'height': '15px'}">
                                                        <ul style="margin-bottom:2px; padding-left: 10px !important;">
                                                            <li *ngIf="submitterPeoplePickr.value"
                                                                class="dropdown-style">
                                                                {{
                                                                    submitterPeoplePickr.get("submitterPeoplePickr")
                                                                    .value
                                                                    ? submitterPeoplePickr.get("submitterPeoplePickr")
                                                                    .value.FullName + " [" +
                                                                    submitterPeoplePickr.get("submitterPeoplePickr")
                                                                    .value.OrgCode + "]"
                                                                    : ""
                                                                    }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <!-- <span *ngIf="submitterPeoplePickr.value">
                                                        {{
                                                        submitterPeoplePickr.get("submitterPeoplePickr")
                                                        .value
                                                        ? submitterPeoplePickr.get("submitterPeoplePickr")
                                                        .value.FullName + " [" +
                                                        submitterPeoplePickr.get("submitterPeoplePickr")
                                                        .value.OrgCode + "]"
                                                        : ""
                                                        }}
                                                    </span> -->
                                                </mat-select-trigger>
                                                <mat-option class="font-control"
                                                    *ngFor="let user of submitterSearchData" [value]="user"
                                                    (click)="assignValueId(user, 'submitter')">
                                                    {{ user.Email }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </div>
                            </div>
                            <div class="activeToggle">
                                <!-- <mat-slide-toggle class="approval-toggle" formControlName="approvalProjectManager">
                                    <label>Accept</label>
                                </mat-slide-toggle> -->
                            </div>
                            <div class="proxyStyle">
                                <!-- <div class="textfield js-textfield textfield-with-prefix">
                                    <input maxlength="50" type="text" aria-label="orgCodeSub"
                                        class="form-control textfield__input invalid" formControlName="orgCodeSub" />
                                </div> -->
                            </div>

                        </div>
                    </div>
                </div>

                <div class="col-md-12 col-lg-12 label-header">
                    <label class="label-headercolor label-text">Milestones and Status
                    </label>
                </div>
                <div class="row">
                    <div class="col-md-3 col-lg-3" style="border-right: 1px solid; top: 10px;">
                        <span style="font-weight: bold; font-size: 0.75rem">M120</span>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>Date </label>
                            </div>
                            <div class="col-md-9 col-lg-9" style="margin-top: 4px;">
                                <input class="ttmp" type="text" aria-label="Datepicker" [matDatepicker]="picker1"
                                    formControlName="dateM120" placeholder=" mm/dd/yyyy" style="width: 50%;" />
                                <mat-datepicker-toggle class="ttmp1" matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </div>
                        </div>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>Achieved </label>
                            </div>
                            <div class="col-md-3 col-lg-3" style="margin-top: 4px;">
                                <mat-slide-toggle class="milestone-toggle" formControlName="achievedM120"
                                    (change)="ontogglechangeM120($event)">
                                </mat-slide-toggle>
                            </div>
                        </div>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>EK slides </label>
                            </div>
                            <div class="col-md-7 col-lg-7">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <input (input)="ekSlideBind($event, false)" type="text " aria-label="EKSlideM120"
                                        class="form-control textfield__input invalid" formControlName="EKSlideM120" />
                                </div>
                            </div>
                            <div class="col-md-0 col-lg-0">
                                <a href="{{ ekSlideValue }}" title="Go To Link: {{ ekSlideValue }}" target="_blank"
                                    rel="noopener" class="form-control textfield__input borderStyle"
                                    style="float: right"><img alt="TFS Link icon" src="../assets/icons/globe.svg"
                                        height="22" width="22" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-lg-3" style="border-right: 1px solid; top: 10px;">
                        <span style="font-weight: bold; font-size: 0.75rem">M150</span>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>Date </label>
                            </div>
                            <div class="col-md-9 col-lg-9" style="margin-top: 4px;">
                                <input class="ttmp" type="text" aria-label="Datepicker" [matDatepicker]="picker2"
                                    formControlName="dateM150" placeholder=" mm/dd/yyyy" style="width: 50%;" />
                                <mat-datepicker-toggle class="ttmp1" matSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </div>
                        </div>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>Achieved </label>
                            </div>
                            <div class="col-md-3 col-lg-3" style="margin-top: 4px;">
                                <mat-slide-toggle class="milestone-toggle" formControlName="achievedM150"
                                    (change)="ontogglechangeM150($event)">
                                </mat-slide-toggle>
                            </div>
                        </div>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>EK slides </label>
                            </div>
                            <div class="col-md-7 col-lg-7">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <input (input)="ekSlideBind($event, false)" type="text " aria-label="EKSlideM150"
                                        class="form-control textfield__input invalid" formControlName="EKSlideM150" />
                                </div>
                            </div>
                            <div class="col-md-0 col-lg-0">
                                <a href="{{ ekSlideValue }}" title="Go To Link: {{ ekSlideValue }}" target="_blank"
                                    rel="noopener" class="form-control textfield__input borderStyle"
                                    style="float: right"><img alt="TFS Link icon" src="../assets/icons/globe.svg"
                                        height="22" width="22" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-lg-3" style="border-right: 1px solid; top: 10px;">
                        <span style="font-weight: bold; font-size: 0.75rem">M200</span>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>Date </label>
                            </div>
                            <div class="col-md-9 col-lg-9" style="margin-top: 4px;">
                                <input class="ttmp" type="text" aria-label="Datepicker" [matDatepicker]="picker3"
                                    formControlName="dateM200" placeholder=" mm/dd/yyyy" style="width: 50%;" />
                                <mat-datepicker-toggle class="ttmp1" matSuffix [for]="picker3"></mat-datepicker-toggle>
                                <mat-datepicker #picker3></mat-datepicker>
                            </div>
                        </div>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>Achieved </label>
                            </div>
                            <div class="col-md-3 col-lg-3" style="margin-top: 4px;">
                                <mat-slide-toggle class="milestone-toggle" formControlName="achievedM200"
                                    (change)="ontogglechangeM200($event)">
                                </mat-slide-toggle>
                            </div>
                        </div>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>EK slides </label>
                            </div>
                            <div class="col-md-7 col-lg-7">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <input (input)="ekSlideBind($event, false)" type="text " aria-label="EKSlideM200"
                                        class="form-control textfield__input invalid" formControlName="EKSlideM200" />
                                </div>
                            </div>
                            <div class="col-md-0 col-lg-0">
                                <a href="{{ ekSlideValue }}" title="Go To Link: {{ ekSlideValue }}" target="_blank"
                                    rel="noopener" class="form-control textfield__input borderStyle"
                                    style="float: right"><img alt="TFS Link icon" src="../assets/icons/globe.svg"
                                        height="22" width="22" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-lg-3" style="top: 10px;">
                        <span style="font-weight: bold; font-size: 0.75rem">M300</span><span
                            class="asterisk_input">*</span>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>Date </label>
                            </div>
                            <div class="col-md-9 col-lg-9" style="margin-top: 4px;">
                                <input class="ttmp" type="text" aria-label="Datepicker" [matDatepicker]="picker4"
                                    formControlName="dateM300" placeholder=" mm/dd/yyyy" style="width: 50%;" />
                                <mat-datepicker-toggle class="ttmp1" matSuffix [for]="picker4"></mat-datepicker-toggle>
                                <mat-datepicker #picker4></mat-datepicker>
                            </div>
                        </div>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>Achieved </label>
                            </div>
                            <div class="col-md-3 col-lg-3" style="margin-top: 4px;">
                                <mat-slide-toggle class="milestone-toggle" formControlName="achievedM300"
                                    (change)="ontogglechangeM300($event)" [checked]="checked">
                                </mat-slide-toggle>
                            </div>
                        </div>
                        <div class="row row-height row-style">
                            <div class="col-md-3 col-lg-3">
                                <label>EK slides </label>
                            </div>
                            <div class="col-md-7 col-lg-7">
                                <div class="textfield js-textfield textfield-with-prefix">
                                    <input (input)="ekSlideBind($event, false)" type="text " aria-label="EKSlideM300"
                                        class="form-control textfield__input invalid" formControlName="EKSlideM300" />
                                </div>
                            </div>
                            <div class="col-md-0 col-lg-0">
                                <a href="{{ ekSlideValue }}" title="Go To Link: {{ ekSlideValue }}" target="_blank"
                                    rel="noopener" class="form-control textfield__input borderStyle"
                                    style="float: right"><img alt="TFS Link icon" src="../assets/icons/globe.svg"
                                        height="22" width="22" /></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row row-height row row-height-height row-style"
                    style="margin-top: 30px; margin-bottom: 10px;">
                    <div class="col-md-auto col-lg-auto">
                        <label for="projectStatus" class="label">Overall Project Status <span
                                class="asterisk_input">*</span>
                        </label>
                    </div>
                    <div class="col-md-3 col-lg-3">
                        <select id="projectStatus" class="form-control invalid" aria-label="status"
                            formControlName="ProjectStatusId"
                            style="margin-top: 4px; height: 30px !important; font-size: 0.7rem !important; padding: 1px;">
                            <option value="">Please select</option>
                            <option *ngFor="let s of status.Data" [value]="s.ProjectStatusId">
                                {{s.ProjectStatusTitle}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-md-12 col-lg-12 label-header">
                    <label class="label-headercolor label-text">Rationale
                    </label>
                </div>
                <div class="row" style="margin-top: 10px; margin-bottom: 10px;">
                    <div class="col-md-3 col-lg-1">
                        <label>Title <span class="asterisk_input">*</span></label>
                    </div>
                    <div class="col-md-9 col-lg-11">
                        <div class="textfield js-textfield textfield-with-prefix"
                            style="margin-bottom: -1.66667rem !important;">
                            <input maxlength="255" type="text" aria-label="title"
                                class="form-control textfield__input invalid" formControlName="title" />
                        </div>
                    </div>
                </div>

                <div class="row" style="margin-top: 10px; margin-bottom: 10px;">
                    <div class="col-md-1 col-lg-1">
                        <label> DNA <span class="asterisk_input">*</span></label>
                    </div>
                    <!-- <div class="col-md-4 col-lg-4">
                         <textarea id="DNAtestArea" style="font-size: 0.7rem; width: 99%" aria-label="Remarks_Target"
                        [(ngModel)]="DNAremark"    cols="75" rows="3" maxlength="1500" wrap="hard">
                     
                            </textarea>
                   
                  
                    </div> -->
                    <div class="col-md-5 col-lg-5">
                        <!-- <textarea id="DNAtestArea" style="font-size: 0.7rem; width: 99%; height: 102%;"
                            aria-label="Remarks_Target" pInputTextarea formControlName="DNA" cols="75" rows="3"
                            maxlength="1500" wrap="hard"></textarea> -->
                        <div style="width:100%;float: left; margin-left: 1px;">
                            <quill-editor class="custom-quill" [modules]="quillModules" id="DNAtestArea" required
                                formControlName="DNA" (keyup)="onKeyUp($event)" role="textbox" name="DNA"
                                required></quill-editor>
                        </div>
                    </div>

                    <div class="col-md-1 col-lg-1">
                        <label> Epics <span class="asterisk_input">*</span></label>
                    </div>
                    <div class="col-md-5 col-lg-5">
                        <div style="width: 100%; float: left; margin-left: 1px;">
                            <div class="label-header" style=" border-radius: 3px; margin-top: 0px !important">
                                <label class="label-headercolor" style="padding-bottom: 0px">Click
                                    <button type="button" aria-label="Add" (click)="AddNewRowMMP()"
                                        [disabled]="!isEditable" [ngClass]="{ 'click-not-allowed': !isEditable }">
                                        <img alt="Plus Icon" src="../assets/icons/Plus.svg" width="25" height="25" />
                                    </button>
                                    to add new item</label>
                            </div>

                            <ag-grid-angular id="mmpGrid" style="width: 100%; height: 272px; border: 1px solid #e6e6e6;"
                                class="ag-theme-alpine" [rowData]="mmpRowData" [columnDefs]="mmpColumnDefs"
                                [defaultColDef]="defaultColDef" (rowClicked)="onRowClicked($event)"
                                [gridOptions]="mmpGridOptions" [popupParent]="popupParent"
                                (gridReady)="mmpGridReady($event)" (cellValueChanged)="onCellValueChanged($event)"
                                (gridSizeChanged)="onGridSizeChanged($event)"
                                [frameworkComponents]="frameworkComponents" [enableBrowserTooltips]="true"
                                (columnResized)="onColumnResized($event)" (columnVisible)="onColumnVisible($event)"
                                [dataTypeDefinitions]="dataTypeDefinitions" [rowHeight]="30">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row" style="height: 65px;">
                <div class="offset-6 col-md-6">
                    <div style="float: right; margin-top: 10px">
                        <button class="button button--small" (click)="onClickCancel()">
                            Cancel & Exit</button>&nbsp;
                        <button class="button button--small" (click)="onClickNext()"
                            [disabled]="submitted || (!hasUnsavedChanges && projectId == null)">
                            Next</button>&nbsp;
                        <button class="button button--small" type="submit" [disabled]="submitted || !isEditable"
                            (click)="submit($event)">
                            Save & Exit
                        </button>
                    </div>
                </div>
            </div>
            <!-- validation Business Area -->
            <div>
                <span id="title6" *ngIf="projectForm.get('businessAreaName').invalid; else nextArea">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "Business Area",
                    "false"
                    )
                    }}</span>
                <ng-template #nextArea>{{
                    getErrorMessage("", "Business Area", "true")
                    }}</ng-template>
            </div>
            <!-- validation Business Line -->
            <div>
                <span id="title7" *ngIf="projectForm.get('businessLineName').invalid; else nextLine">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "Business Line",
                    "false"
                    )
                    }}</span>
                <ng-template #nextLine>{{
                    getErrorMessage("", "Business Line", "true")
                    }}</ng-template>
            </div>
            <!-- Validation Submitter -->
            <div>
                <span id="subError" *ngIf="
                submitterPeoplePickr.get('submitterPeoplePickr').invalid;
                else sub
              ">
                    {{
                    getErrorMessage("Its a Required field", "Submitter", "false")
                    }}</span>
                <ng-template #sub>{{
                    getErrorMessage("", "Submitter", "true")
                    }}</ng-template>
            </div>
            <!-- Validation Financial_Controller -->
            <div>
                <span id="fcError" *ngIf="
                financialControllerPeoplePickr.get('financialControllerPeoplePickr').invalid;
                else fc
              ">
                    {{
                    getErrorMessage("Its a Required field", "Financial_Controller", "false")
                    }}</span>
                <ng-template #fc>{{
                    getErrorMessage("", "Financial_Controller", "true")
                    }}</ng-template>
            </div>
            <!-- Validation Product_Manager -->
            <div>
                <span id="productMError" *ngIf="
                productManagerPeoplePickr.get('productManagerPeoplePickr').invalid;
                else productM
              ">
                    {{
                    getErrorMessage("Its a Required field", "Product_Manager", "false")
                    }}</span>
                <ng-template #productM>{{
                    getErrorMessage("", "Product_Manager", "true")
                    }}</ng-template>
            </div>
            <!-- Validation Service_Manager -->
            <div>
                <span id="serviceMError" *ngIf="
                serviceManagerPeoplePickr.get('serviceManagerPeoplePickr').invalid;
                else serviceM
              ">
                    {{
                    getErrorMessage("Its a Required field", "Service_Manager", "false")
                    }}</span>
                <ng-template #serviceM>{{
                    getErrorMessage("", "Service_Manager", "true")
                    }}</ng-template>
            </div>
            <!-- Validation Project_Manager -->
            <!-- <div>
                <span id="projectMError" *ngIf="
                projectManagerPeoplePickr.get('projectManagerPeoplePickr').invalid;
                else projectM
              ">
                    {{
                    getErrorMessage("Its a Required field", "Project_Manager", "false")
                    }}</span>
                <ng-template #projectM>{{
                    getErrorMessage("", "Project_Manager", "true")
                    }}</ng-template>
            </div>
         Validation Procurement_Engineer -->
            <!-- <div>
                <span id="peError" *ngIf="
                procurementEngineerPeoplePickr.get('procurementEngineerPeoplePickr').invalid;
                else pe
              ">
                    {{
                    getErrorMessage("Its a Required field", "Procurement_Engineer", "false")
                    }}</span>
                <ng-template #pe>{{
                    getErrorMessage("", "Procurement_Engineer", "true")
                    }}</ng-template>
            </div> -->
            <!-- validation Title -->
            <div>
                <span id="title" *ngIf="projectForm.get('title').invalid; else nextTitle">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "Title",
                    "false"
                    )
                    }}</span>
                <ng-template #nextTitle>{{
                    getErrorMessage("", "Title", "true")
                    }}</ng-template>
            </div>

            <!-- validation Submitter org code -->
            <div>
                <span id="title3" *ngIf="projectForm.get('orgCodeSub').invalid; else nextScode">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "Submitter_Org_Code",
                    "false"
                    )
                    }}</span>
                <ng-template #nextScode>{{
                    getErrorMessage("", "Submitter_Org_Code", "true")
                    }}</ng-template>
            </div>
            <!-- validation FC org code -->
            <div>
                <span id="fcOrgCode" *ngIf="projectForm.get('orgCodeFC').invalid; else fcCode">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "Financial_Controller_Org_Code",
                    "false"
                    )
                    }}</span>
                <ng-template #fcCode>{{
                    getErrorMessage("", "Financial_Controller_Org_Code", "true")
                    }}</ng-template>
            </div>
            <!-- validation ProductM org code -->
            <div>
                <span id="productMOrgCode" *ngIf="projectForm.get('orgCodeProductM').invalid; else productMCode">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "Product_Manager_Org_Code",
                    "false"
                    )
                    }}</span>
                <ng-template #productMCode>{{
                    getErrorMessage("", "Product_Manager_Org_Code", "true")
                    }}</ng-template>
            </div>
            <!-- validation ServiceM org code -->
            <!-- <div>
                <span id="serviceMOrgCode" *ngIf="projectForm.get('orgCodeServiceM').invalid; else serviceMCode">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "Service_Manager_Org_Code",
                    "false"
                    )
                    }}</span>
                <ng-template #serviceMCode>{{
                    getErrorMessage("", "Service_Manager_Org_Code", "true")
                    }}</ng-template>
            </div> -->
            <!-- validation ProjectM org code -->
            <!-- <div>
                <span id="projectMOrgCode" *ngIf="projectForm.get('orgCodeProjectM').invalid; else projectMCode">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "Project_Manager_Org_Code",
                    "false"
                    )
                    }}</span>
                <ng-template #projectMCode>{{
                    getErrorMessage("", "Project_Manager_Org_Code", "true")
                    }}</ng-template>
            </div> -->
            <!-- validation PE org code -->
            <!-- <div>
                <span id="peOrgCode" *ngIf="projectForm.get('orgCodePE').invalid; else peCode">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "Procurement_Engineer_Org_Code",
                    "false"
                    )
                    }}</span>
                <ng-template #peCode>{{
                    getErrorMessage("", "Procurement_Engineer_Org_Code", "true")
                    }}</ng-template>
            </div> -->
            <!-- validation Overall Project Status -->
            <div>
                <span id="title" *ngIf="projectForm.get('ProjectStatusId').invalid; else nextOPS">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "Overall_Project_Status",
                    "false"
                    )
                    }}</span>
                <ng-template #nextOPS>{{
                    getErrorMessage("", "Overall_Project_Status", "true")
                    }}</ng-template>
            </div>
            <!-- validation DNA -->
            <div>
                <span id="title" *ngIf="projectForm.get('DNA').invalid; else nextDNA">
                    {{
                    getErrorMessage(
                    "Its a
                    Required field",
                    "DNA",
                    "false"
                    )
                    }}</span>
                <ng-template #nextDNA>{{
                    getErrorMessage("", "DNA", "true")
                    }}</ng-template>
            </div>
            <br />
        </div>
    </main>
</div>